import {createSelector} from "reselect";
import queryString from 'query-string';


const pointsUrlSelector = (props: any) => {
    return props.location.search
};

export const pointsCityIdReSelector = createSelector(
    [pointsUrlSelector],
    (queryParams) => {
        const getParams = queryString.parse(queryParams);
        return getParams.cityId ? +getParams.cityId : undefined
    }
);
